/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/StatusType/Active/Post
 * @desc Active node component for date
 */

import type { FilterPostActiveLabelProps } from 'labstep-web/components/FilterPost/Active/Label/types';
import { FilterPostNewIndexStatusType } from 'labstep-web/components/FilterPost/NewIndex/StatusType';
import { ICONS } from 'labstep-web/constants/icons';
import { useParamsContext } from 'labstep-web/contexts/params/hook';
import type { IconProps } from 'labstep-web/core/Icon/types';
import { RemoveLabel } from 'labstep-web/core/Label/Remove';
import {
  ExperimentWorkflowStatusKeys,
  ExperimentWorkflowStatusTypeValues,
} from 'labstep-web/models/experiment-workflow.model';
import {
  PostFilterStatusTypeCompleted,
  PostFilterStatusTypeStarted,
  PostFilterStatusTypeUnstarted,
} from 'labstep-web/services/postFilter/filters/statusType';
import { QueryParameterService } from 'labstep-web/services/query-parameter.service';
import type React from 'react';
export const getNameAndIcon = (
  statusType: string,
): { name: string; icon: IconProps['name'] } => ({
  name: ExperimentWorkflowStatusTypeValues[
    statusType as keyof typeof ExperimentWorkflowStatusTypeValues
  ],
  icon: ICONS.experiment_workflow.info[
    statusType as keyof typeof ICONS.experiment_workflow.info
  ],
});

export const FilterPostNewIndexStatusTypeActivePost: React.FC<
  FilterPostActiveLabelProps
> = ({ node, onRemoveClick }) => {
  const FILTERS = [
    PostFilterStatusTypeUnstarted,
    PostFilterStatusTypeStarted,
    PostFilterStatusTypeCompleted,
  ];
  const { addPostFilter } = useParamsContext();
  const filterActive = FILTERS.find((filter) =>
    filter.isNodeActive(node),
  );
  if (!filterActive) {
    return null;
  }

  if (
    QueryParameterService.isPostFilterNodeType(node.predicates[0])
  ) {
    let value = '';
    if (filterActive === PostFilterStatusTypeUnstarted) {
      value = ExperimentWorkflowStatusKeys.unstarted;
    }
    if (filterActive === PostFilterStatusTypeStarted) {
      value = ExperimentWorkflowStatusKeys.started;
    }
    if (filterActive === PostFilterStatusTypeCompleted) {
      value = ExperimentWorkflowStatusKeys.completed;
    }

    return (
      <FilterPostNewIndexStatusType
        defaultValues={{
          option: {
            label:
              ExperimentWorkflowStatusTypeValues[
                value as keyof typeof ExperimentWorkflowStatusTypeValues
              ],
            value,
          },
        }}
        addPostFilter={addPostFilter}
        viewComponent={({ toggleModal }) => (
          <RemoveLabel
            {...getNameAndIcon(value as string)}
            onNameClick={toggleModal}
            onRemoveClick={onRemoveClick}
          />
        )}
      />
    );
  }
  return null;
};
